import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// STATIC PAGES
import AboutUsPage from 'src/pages/main-dashboard/about-us/about-us-page';
import FaqPage from 'src/pages/main-dashboard/faq/faq-page';
import PrivacyPolicyPage from 'src/pages/main-dashboard/privacy-policy/privacy-policy-page';
import SupportPage from 'src/pages/main-dashboard/support/support-page';
import TacPage from 'src/pages/main-dashboard/terms-and-conditions/tac-page';
import AnnoucementPage from 'src/pages/main-dashboard/annoucements/annoucement-page';
import AccountPage from 'src/pages/main-dashboard/user/account';

// ----------------------------------------------------------------------
// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/ecommerce'));
const OverviewAnalyticsPage = lazy(() => import('src/pages/dashboard/analytics'));
const OverviewBankingPage = lazy(() => import('src/pages/dashboard/banking'));
const OverviewBookingPage = lazy(() => import('src/pages/dashboard/booking'));
const OverviewFilePage = lazy(() => import('src/pages/dashboard/file'));

// USER
const UserProfilePage = lazy(() => import('src/pages/main-dashboard/user/profile'));
const UserListPage = lazy(() => import('src/pages/main-dashboard/user/list'));

// FILE MANAGER
const FileManagerPage = lazy(() => import('src/pages/dashboard/file-manager'));

// APP
const ChatPage = lazy(() => import('src/pages/dashboard/chat'));
const MailPage = lazy(() => import('src/pages/dashboard/mail'));
const CalendarPage = lazy(() => import('src/pages/dashboard/calendar'));
const KanbanPage = lazy(() => import('src/pages/dashboard/kanban'));
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));
const IssuesProfilePage = lazy(() => import('src/pages/main-dashboard/issues/profile'));
const IssuesListPage = lazy(() => import('src/pages/main-dashboard/issues/list'));

const RidesListPage = lazy(() => import('src/pages/main-dashboard/rides/list'));
const RidesProfilePage = lazy(() => import('src/pages/main-dashboard/rides/profile'));


const ContactUsPage = lazy(() => import('src/pages/main-dashboard/support/contact-us-page')); 

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'common-questions', element: <FaqPage /> },
      { path: 'about-us', element: <AboutUsPage /> },
      { path: 'annoucements', element: <AnnoucementPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'terms-and-conditions', element: <TacPage /> },
      // USERS
      {
        path: 'users',
        children: [
          { element: <UserListPage />, index: true },
          { path: 'profile/:id', element: <UserProfilePage /> },
          { path: 'account', element: <AccountPage /> },
        ],
      },
      {
        path: 'requests',
        children: [
          { element: <SupportPage />, index: true },
          { path: 'contact-support', element: <SupportPage /> },
          { path: 'contact-us', element: <ContactUsPage /> },
        ],
      },
      // DASHBOARD EXAMPLES
      { path: 'ecommerce', element: <OverviewEcommercePage /> },
      { path: 'analytics', element: <OverviewAnalyticsPage /> },
      { path: 'banking', element: <OverviewBankingPage /> },
      { path: 'booking', element: <OverviewBookingPage /> },
      { path: 'file', element: <OverviewFilePage /> },
      // ACCOUNTS
      {
        path: 'issues',
        children: [
          { element: <IssuesListPage />, index: true },
          { path: 'profile/:id', element: <IssuesProfilePage /> },
          { path: 'list', element: <IssuesListPage /> },
        ],
      },
      {
        path: 'rides',
        children: [
          { element: <RidesListPage />, index: true },
          { path: 'profile/:id', element: <RidesProfilePage /> },
          { path: 'list', element: <RidesListPage /> },
        ],
      },
      // APPS
      { path: 'file-manager', element: <FileManagerPage /> },
      { path: 'mail', element: <MailPage /> },
      { path: 'chat', element: <ChatPage /> },
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'kanban', element: <KanbanPage /> },
      { path: 'blank', element: <BlankPage /> },
    ],
  },
];
